/**
 * @file Photo pricings related fragments.
 */

import gql from 'graphql-tag';

import { VendorDetails } from './account';
import {
  printProductBaseDetails,
  printProductSizeBaseDetails,
  printProductSizeRoesGraphicNodeDetails,
} from './print-product';

export const PhotoPricingPrintProductConfigurationDetails = gql`
  fragment PhotoPricingPrintProductConfigurationDetails on PhotoPricingPrintProductItem {
    id
    print_product_configuration {
      name
      print_product {
        id
        name
      }
      print_product_size {
        print_size {
          id
          name
        }
        price {
          value
          currency
        }
        min_price {
          value
          currency
        }
        roes_info {
          graphic_nodes(slice: { limit: 99 }) {
            total
            records {
              ...printProductSizeRoesGraphicNodeDetails
            }
          }
        }
      }
      print_product_size_roes_graphic_node {
        ...printProductSizeRoesGraphicNodeDetails
      }
    }
  }
  ${printProductSizeRoesGraphicNodeDetails}
`;

export const PhotoPricingPrintProductConfigurationForPurchaseDetails = gql`
  fragment PhotoPricingPrintProductConfigurationForPurchaseDetails on PhotoPricingPrintProductItem {
    id
    print_product_configuration {
      name
      print_product {
        ...printProductBaseDetails
      }
      print_product_size {
        ...printProductSizeBaseDetails
      }
      print_product_size_roes_graphic_node {
        ...printProductSizeRoesGraphicNodeDetails
      }
    }
  }
  ${printProductBaseDetails}
  ${printProductSizeBaseDetails}
  ${printProductSizeRoesGraphicNodeDetails}
`;

export const PhotoPricingDetails = gql`
  fragment PhotoPricingDetails on PhotoPricing {
    id
    name
    requires_package_purchase
    digital_downloads_price {
      value
      currency
    }
    account {
      ...VendorDetails
    }
    print_items(slice: { limit: 9999 }) {
      total
      records {
        id
        price {
          value
          currency
        }
        type {
          id
          name
          min_price {
            value
            currency
          }
        }
      }
    }
    print_product_items(slice: { limit: 9999 }) {
      total
      records {
        id
        print_product {
          id
          name
        }
        print_product_size {
          id
          print_size {
            id
            name
          }
          price {
            value
            currency
          }
          min_price {
            value
            currency
          }
        }
        price {
          value
          currency
        }
        ...PhotoPricingPrintProductConfigurationDetails
      }
    }
    print_partner {
      id
      name
    }
    pricing_category {
      id
      name
    }
    pricing_categories {
      total
      records {
        id
        pricing_category {
          id
          name
        }
      }
    }
    print_assets(slice: { limit: 999 }) {
      total
      records {
        id
        print_asset {
          id
          name
          type
          jersey_colors(slice: { limit: 999 }) {
            records {
              id
              jersey_color
            }
          }
          asset_image {
            id
            url
            width
            height
          }
        }
      }
    }
  }
  ${VendorDetails}
  ${PhotoPricingPrintProductConfigurationDetails}
`;

export const AlbumPhotoPricingDetails = gql`
  fragment AlbumPhotoPricingDetails on PhotoPricing {
    id
    albums {
      records {
        id
        name
      }
    }
  }
`;

export const PhotoPricingForPurchaseDetails = gql`
  fragment PhotoPricingForPurchaseDetails on PhotoPricing {
    id
    account {
      ...VendorDetails
    }
    digital_downloads_price {
      value
      currency
    }
    requires_package_purchase
    print_product_items(slice: { limit: 99 }) {
      total
      records {
        id
        print_product {
          ...printProductBaseDetails
        }
        print_product_size {
          ...printProductSizeBaseDetails
        }
        print_product_size_mount {
          id
        }
        name
        price {
          currency
          value
        }
      }
    }
    print_items(slice: { limit: 99 }) {
      total
      records {
        id
        price {
          value
          currency
        }
        type {
          id
          name
        }
      }
    }
    print_assets(slice: { limit: 999 }) {
      total
      records {
        id
        print_asset {
          id
          name
          type
          jersey_colors(slice: { limit: 999 }) {
            records {
              id
              jersey_color
            }
          }
          asset_image {
            id
            url
            width
            height
          }
        }
      }
    }
  }
  ${printProductBaseDetails}
  ${printProductSizeBaseDetails}
  ${VendorDetails}
`;
